<template>
  <div id="checkpoint" class="checkpoint">
    <div class="d-flex align-items-center justify-content-between checkpoint__header">
      <h2>Check point {{ ((new Date(general.interview_start_time.replace(/ /g,"T"))).getMonth() + 1).toString().padStart(2, '0') + '/' + (new Date(general.interview_start_time.replace(/ /g,"T"))).getFullYear() }}</h2>

      <router-link to="/checkpoint/guide" class="btn btn-guide mb-0">
        Hướng dẫn
        <img src="../../assets/icons/icon_question_05.svg" alt="guide">
      </router-link>
    </div>

    <div class="row">
      <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4 col-xxll-3">
        <CheckPointOverviewBox index="1" :status="mySelfEvalute" cls="active">
          <img src="../../assets/images/img_checkpoint_01.png" alt="Tự đánh giá">
          <b class="text-center">Tự đánh giá</b>

          <template v-if="!mySelfEvalute">
            <p>Trạng thái: <span class="text-danger">Chưa đánh giá</span></p>
            <router-link :class="!canCheck ? 'disable':''" to="/checkpoint/myself" class="btn btn-guide mt-2">Đánh giá ngay</router-link>
          </template>

          <template v-else>
            <p>Trạng thái: <span class="text-success">Đã đánh giá</span></p>
<!--            <button v-if="allowEditRequest" @click="$refs.editCheckPointConfirm.open()" class="btn checkpoint__edit text-center d-flex align-items-center">-->
<!--              Yêu cầu chỉnh sửa-->
<!--              <img src="../../assets/icons/icon_user_09.svg" class="ml-1 mr-0" alt="icon">-->
<!--            </button>-->

            <router-link v-if="btnSeeReview" to="/checkpoint/see-review" class="btn btn-guide">Xem đánh giá</router-link>
          </template>
        </CheckPointOverviewBox>
      </div>

      <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4 col-xxll-3">
        <CheckPointOverviewBox index="2" :status="pmEvalute" :cls="pmEvalute || mySelfEvalute ? 'active':''">
          <img src="../../assets/images/img_checkpoint_02.png" alt="Quản lý trực tiếp đánh giá">
          <b class="text-center">Quản lý trực tiếp đánh giá</b>

          <template v-if="!pmEvalute">
            <span class="mb-1 text-center">{{ pmNameList }}</span>
            <p>Trạng thái: <span class="text-danger">Chưa đánh giá</span></p>
          </template>
          <template v-else>
            <span class="mb-1 text-center">{{ pmNameList }}</span>
            <p>Trạng thái: <span class="text-success">Đã đánh giá</span></p>
          </template>
        </CheckPointOverviewBox>
      </div>

      <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4 col-xxll-3">
        <CheckPointOverviewBox index="3" :status="dmEvalute" :cls="pmEvalute || dmEvalute ? 'active':''">
          <img src="../../assets/images/img_checkpoint_03.png" alt="Trưởng bộ phận đánh giá">
          <b class="text-center">Trưởng bộ phận đánh giá</b>

          <template v-if="!dmEvalute">
            <span class="mb-1">{{ dmName }}</span>
            <p>Trạng thái: <span class="text-danger">Chưa đánh giá</span></p>
          </template>

          <template v-else>
            <span class="mb-1">{{ dmName }}</span>
            <p>Trạng thái: <span class="text-success">Đã đánh giá</span></p>
          </template>
        </CheckPointOverviewBox>
      </div>

      <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4 col-xxll-3">
        <CheckPointOverviewBox index="4" :status="interviewed" :cls="box4status ? 'active':''">
          <img src="../../assets/images/img_checkpoint_04.png" alt="Trao đổi trực tiếp">
          <b class="text-center">Trao đổi trực tiếp</b>
          <p>Thời gian: <span>{{ !general.interview_time ? 'Chưa có thông tin' : '' + general.interview_time }}</span></p>
          <p>Địa điểm: <span>{{ general.interview_location }}</span></p>
        </CheckPointOverviewBox>
      </div>
    </div>

    <template v-if="hasResult">
      <div class="checkpoint__result">
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex flex-column align-items-center justify-content-center">
            <p>Xem kết quả đánh giá của bạn tại đây</p>
            <router-link to="/checkpoint/result" class="btn">Xem kết quả</router-link>
          </div>

          <img src="../../assets/images/img_checkpoint_07.png" alt="result">
        </div>
      </div>
    </template>

    <TheModal ref="editCheckPointConfirm">
       <div class="d-flex flex-column justify-content-center align-items-center">
         <b class="mb-3">Gửi yêu cầu chỉnh sửa của bạn với quản lý!</b>
         <div>
           <button @click="$refs.editCheckPointConfirm.close()" class="btn btn-outline-dark mr-3">Hủy bỏ</button>
           <button @click="requestEdit()" class="btn btn-guide">Xác nhận</button>
          </div>
       </div>
    </TheModal>
  </div>
</template>

<script>
import TheModal from '../../components/commons/TheModal.vue';
import CheckPointOverviewBox from './CheckPointOverviewBox.vue';
import { mapGetters } from 'vuex';

export default {
  components: { CheckPointOverviewBox, TheModal },
  name: "CheckPointOverview",
  async created() {
    this.$root.$loading.start();
    await this.$store.dispatch('checkpoint/getGeneralReview').then((response) => {
      localStorage.setItem('user_code', response.data.user_checkpoint_id.join(','))
      this.$root.$loading.finish();
    }).catch(() => {
      this.$root.$loading.finish();
      this.$toast('Có lỗi xảy ra! thử  lại sau.', 'Lỗi hệ thống', 2000, 'b-toaster-top-center', 'danger');
    })
  },
  computed: {
    ...mapGetters({
      general: 'checkpoint/general',
      canCheck: 'checkpoint/canCheck'
    }),

    allowEditRequest() {
      if (this.general) {
        let allow = false;
        if (this.general.request_member_edit_form === 0 && !this.dmEvalute && !this.pmEvalute && !this.hasResult && !this.findPmReview) {
          allow = true;
        }

        return allow;
      }

      return false;
    },

    box4status() {
      let check = false;
      if (this.interviewed || this.general.view_result_flg === 1) {
        check = true;
      }

      return check;
    },

    btnSeeReview() {
      let check = false;
      if (!this.dmEvalute && !this.hasResult) {
        check = true;
      }

      return check;
    },

    mySelfEvalute() {
      if (this.general.member_review === 0) {
        return false;
      }
      return true;
    },

    pmEvalute() {
      let check = true;

      if (this.general.pm_review) {
        this.general.pm_review.forEach(item => {
          if (item.review_flag === 0) {
            check = false;
          }
        })
      }

      return check;
    },

    findPmReview() {
      let check = false;

      if (this.general.pm_review) {
        this.general.pm_review.forEach(item => {
          if (item.review_flag === 1) {
            check = true;
          }
        })
      }

      return check;
    },

    pmNameList() {
      let pmNames = [];
      if (this.general.pm_review) {
        pmNames = this.general.pm_review.map(item => item.pm_name);
        // unique pm name
        pmNames = new Set(pmNames);
      }

      return Array.from(pmNames).join(', ');
    },

    dmEvalute() {
      if (this.general.dm_review) {
        if (this.general.dm_review.review_flag === 1) {
          return true;
        }
      }
      return false;
    },

    dmName() {
      if (this.general.dm_review) {
        return this.general.dm_review.dm_name;
      }
      return '';
    },

    interviewed() {
      if (this.general.done_review === 0) {
        return false;
      }
      return true;
    },

    hasResult() {
      if (this.general.view_result_flg === 0) {
        return false;
      }
      return true;
    }
  },
  methods: {
    async requestEdit() {
      // api
      this.$root.$loading.start();
      this.$root.$loading.finish();
      this.$refs.editCheckPointConfirm.close();
    }
  }
}
</script>

<style lang="scss" scoped>

#checkpoint {
  padding: 0 30px;

  & /deep/ .t-modal {
    &-body {
      button {
        min-width: 140px;
        height: 42px;
      }
    }
  }

  & /deep/ .ov {
    min-height: 363px;
  }
}

.btn-guide {
  background: #A6D7F6;
  color: #303C54;

  img {
    width: 20px;
    height: 20px;
  }

  &.disable {
    pointer-events: none;
    opacity: .7;
  }
}

.checkpoint {
  &__header {
    margin-bottom: 30px;
    h2 {
      margin-bottom: 0;
      font-size: 28px;
      font-weight: bold;
    }
  }

  &__edit {
    color: #118FA6;
    background-color: transparent;
    img {
      height: 13px;
      width: 16px;
      margin-bottom: 0;
    }

    &:active, &:focus {
      outline: none;
      box-shadow: none;
    }
  }

  &__result {
    margin-bottom: 20px;
    background-color: #fff;
    border-radius: 5px;
    height: 500px;
    padding: 40px 100px;

    p {
      font-weight: bold;
      font-size: 34px;
      margin-bottom: 24px;
    }

    a {
      background-color: #3C8BF1;
      width: 230px;
      height: 60px;
      line-height: 50px;
      font-size: 20px;
      color: #fff;
      border: 0;
    }
  }
}
</style>
